<div class="header">#hex_ installer - FAQs</div>
<div class="faq" *ngFor="let faq of faqs">
  <div class="faq__question">{{faq.question}}</div>
  <div class="faq__answer" [innerHTML]="getSanitizied(faq.answer)"></div>
</div>
